
export {} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$table.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$table.js';export default __x__;